const getters = {
    icalUrl: state => state.icalUrl,
};

export default getters;